export const sessionStorageKeys = {
  /* 
    Used to indicate if the user is visiting our pages from an in-app browser (Sketch app, iOS App, ...)
    This is then used to conditionally render some buttons both in our app and the marketing website
   */
  isForInAppPresentation: 'isForInAppPresentation',
} as const

export type SessionKeys = keyof typeof sessionStorageKeys
